import { Box, Modal, ModalDialog, Stack, styled } from '@mui/joy';
import { css } from '@mui/system';
import { useNavigate } from '@tanstack/react-router';
import { ReactNode } from 'react';

import { CardHeader } from '@/components/card-header/CardHeader';
import { CardHeaderModalClose } from '@/components/card-header/CardHeaderModalClose';
import { CardHeaderTitle } from '@/components/card-header/CardHeaderTitle';

const ContentBox = styled(Box)(
  ({ theme }) => css`
    background-color: ${theme.palette.common.white};
    border-bottom-left-radius: ${theme.radius.xl};
    border-bottom-right-radius: ${theme.radius.xl};
    padding: ${theme.spacing(4)};
    overflow: auto;
  `,
);

type EditModalDialogProps = { title?: string; children: ReactNode; onClose?: () => void };

export function EditModalDialog({ title, children, onClose }: EditModalDialogProps) {
  const navigate = useNavigate();

  return (
    <Modal open onClose={() => (onClose ? onClose() : navigate({ to: '..' }))}>
      <ModalDialog minWidth="sm" maxWidth="sm" sx={{ padding: 0, gap: 0 }}>
        <CardHeader>
          <Stack direction="row" gap={2}>
            <CardHeaderTitle>{title}</CardHeaderTitle>
          </Stack>
          <CardHeaderModalClose />
        </CardHeader>
        <ContentBox>{children}</ContentBox>
      </ModalDialog>
    </Modal>
  );
}
